import React from 'react';

interface MultiSelectButtonProps {
  label: React.ReactNode;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
}


export function MultiSelectButton({ label, selected, onClick, disabled = false }: MultiSelectButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`p-2 text-sm rounded-lg border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
        selected
          ? 'bg-brand-primary text-white border-brand-primary'
          : 'bg-background-white border-border-primary hover:bg-background-secondary'
      }`}
    >
      {label}
    </button>
  );
}